import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { environment } from '@environment';
import { TIME_TO_SLIDE, ANIMATIONS } from '@app/constants/animations.constants';
import { AppFacade } from '@app/app.facade';
import { Countries } from '@ux/entities/country.enum';
import { MobileDeviceService } from '@app/services/mobile-device.service';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TermsConditionsComponent {

  @Input() disabledBack: boolean = false;

  @Output() closeTerms: EventEmitter<void> = new EventEmitter<void>();

  public animation: string = ANIMATIONS.SLIDE_IN_RIGHT;
  public booking: string = 'booking';

  constructor(
    private facade: AppFacade,
    private router: Router,
    private mobileDeviceService: MobileDeviceService,
  ) { }

  get isMobile$(): Observable<boolean> {
    return this.mobileDeviceService.isMobileDevice$;
  }

  public goBack(): void {
    if (!this.disabledBack) {
      this.animation = ANIMATIONS.SLIDE_OUT_RIGHT;
      this.facade.historyPop();
      setTimeout(() => this.facade.navigateToLastRoute(), TIME_TO_SLIDE);
    } else this.closeTerms.emit();
  }

  get isBookingRoute(): boolean {
    return this.router.url.includes(this.booking);
  }

  get isBR(): boolean {
    return environment.countryInfo.iso_code === Countries.Brazil;
  }

  get isCO(): boolean {
    return environment.countryInfo.iso_code === Countries.Colombia;
  }

  get isMX(): boolean {
    return environment.countryInfo.iso_code === Countries.Mexico;
  }

  get isAR(): boolean {
    return environment.countryInfo.iso_code === Countries.Argentina;
  }

  get isPE(): boolean {
    return environment.countryInfo.iso_code === Countries.Peru;
  }

  get isCL(): boolean {
    return environment.countryInfo.iso_code === Countries.Chile;
  }

  get isUY(): boolean {
    return environment.countryInfo.iso_code === Countries.Uruguay;
  }

}
